module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDIwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC40Nzc1IDguOTk5MDJMMi4yNTAzIDIuMjQ5MDJMMTguNzA0OCAyLjI0OTAyTDEwLjQ3NzUgOC45OTkwMloiIGZpbGw9IiNEQkMzOUIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shareFiesta/next.svg
// module id = v11j
// module chunks = 0